module.exports = __webpack_public_path__ + "static/img/game-1.4f44ed3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game-1.png
// module id = ce8/
// module chunks = 1